import { render, staticRenderFns } from "./MailSubjectEditor.vue?vue&type=template&id=5270e990&scoped=true"
import script from "./MailSubjectEditor.vue?vue&type=script&lang=js"
export * from "./MailSubjectEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270e990",
  null
  
)

export default component.exports